import {
  createSelector
} from "reselect"
import {
  getPresets
} from "./config"


export const isFabricInfoOpened = state => state.ui.fabricInfoOpened
export const isFilterMenuOpened = state => state.ui.filterMenuOpened
export const getBuilderPage = state => state.ui.builderPage
export const getActiveDetailsPreset = state => state.ui.activeDetailsPreset
export const isFontSelectorOpened = state => state.ui.isFontSelectorOpened
export const getModalState = state => state.ui.modalState;
export const isCatalogProductOpened = state => state.ui.catalogProductOpened
export const getModalstate = state => state.ui.modalState;
export const getSelectefFabricPreview = state => state.ui && state.ui.fabricPreview;

export const makeIsModalOpened = (modalId) => (
  createSelector(getModalState,
    (modals) => {
      return modals[modalId].isOpened;
    }
  )
);


export const getActivePreset = createSelector(
  (state) => state.ui.activeDetailsPreset,
  getPresets,
  (activePresetId, presets) => {
    if (presets.hasOwnProperty(activePresetId)) {
      return presets[activePresetId];
    }
    return {};
  }
)

export const getContrastModalState = createSelector(
  getModalState,
  (state) => state['CONTRAST_PREVIEW']
)

